import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { RULE_TYPE } from 'pages/user-preferences/utils/constant';
import Select from 'components/select';
import { OrderPayload } from 'pages/user-preferences/store';

export const RuleType = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);

    const fetchRuleTypes = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(RULE_TYPE);
            }, 1000);
        });
    };

    const setRuleType = (ruleType) => {
        const updatedRuleRows = [...order?.ruleRows];
        updatedRuleRows[index] = { ...updatedRuleRows?.[index], ruleType, value: null };
        setOrder({
            ...order,
            ruleRows: updatedRuleRows,
        });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const handleOnSelectChange = (selected) => setRuleType(selected?.value);

    React.useEffect(() => {
        const fetchRuleTypeData = async () => {
            const data = await fetchRuleTypes();
            setOptions(data);
        };
        fetchRuleTypeData();
    }, []);

    React.useEffect(() => {
        resetOptions();
        fetchRuleTypes().then((data) => setOptions(data));
    }, []);

    React.useEffect(() => {
        if (!order?.ruleRows?.[index]?.ruleType && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.ruleRows?.[index]?.ruleType, order?.isTouched]);

    const getFilteredOptions = () => {
        const selectedRuleTypes = order?.ruleRows?.map((row, i) => (i !== index ? row?.ruleType : null))?.filter(Boolean);
        return options?.filter((option) => !selectedRuleTypes?.includes(option?.value) || option?.value === order?.ruleRows?.[index]?.ruleType);
    };

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                key={`ruleType-${index}`}
                dataTestId={`ruleType-autocomplete-${index}`}
                label="Select"
                value={order?.ruleRows?.[index]?.ruleType || ''}
                options={getFilteredOptions()}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isLoading={false}
                isRequired={isTouched}
            />
        </Box>
    );
};

RuleType.propTypes = {
    index: PropTypes.number.isRequired,
};

export default React.memo(RuleType);
